// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type FilterIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from filter.svg
 */
export default function FilterIcon(props: FilterIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="FilterIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M16 3a1 1 0 0 0-1-1H1l-.117.007A1 1 0 0 0 1 4h14l.117-.007A1 1 0 0 0 16 3m-3 4a1 1 0 0 1 .117 1.993L13 9H3a1 1 0 0 1-.117-1.993L3 7zm-2 5a1 1 0 0 1 .117 1.993L11 14H5a1 1 0 0 1-.117-1.993L5 12z"
        />
      </g>
    </svg>
  );
}
